import { useContext } from 'react';
import RegistrationLayout from '../../Components/RegistrationLayout/RegistrationLayout';
import { RegistrationContext } from '../../Context/RegistrationContext';
import Input from './Input';
import ImageAdd from '../../Assets/Add image.svg';
import LoadingTransparent from '../../Components/Loading/LoadingTransparent';
import { useNavigate } from 'react-router-dom';

function SectionComponent() {
    const {
        // Bank Details
        bankDetails,
        setBankDetails,
        bankErrors,
        setBankErrors,
        defaultBankErrors,
        chequeFile,
        setChequeFile,
    } = useContext(RegistrationContext);

    const navigate = useNavigate();

    function handleChange(e) {
        const { name, value } = e.target;

        if (name === 'accountNumber') {
            const numericValue = value.replace(/\D/g, '');
            setBankDetails(prev => ({ ...prev, [name]: numericValue }));
        } else {
            setBankDetails(prev => ({ ...prev, [name]: value }));
        }
    }

    async function processCheque(file) {
        if (!file) return;

        // Size validation (10MB limit)
        if (file.size > 10 * 1024 * 1024) {
            setBankErrors(prev => ({
                ...prev,
                cancelledChequeUrl: 'File size should be less than 10MB',
            }));
            return;
        }

        // ✅ File accepted
        setChequeFile(file);
        setBankErrors(prev => ({
            ...prev,
            cancelledChequeUrl: '',
        }));
    }

    async function handleChequeSelection(e) {
        const file = e.target.files[0];
        await processCheque(file);
        e.target.value = null; // reset input for re-upload
    }

    const handleDropCheque = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const file = e.dataTransfer.files[0];
        await processCheque(file);
    };

    const handleDragOverCheque = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDragLeaveCheque = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    async function handleNext() {
        const validationErrors = {};

        if(!bankDetails.accountHolderName) {
            validationErrors.accountHolderName = 'Required field';
        }

        if(!bankDetails.accountNumber) {
            validationErrors.accountNumber = 'Required field';
        }

        if(!bankDetails.confirmAccountNumber) {
            validationErrors.confirmAccountNumber = 'Required field';
        }

        if(bankDetails.accountNumber !== bankDetails.confirmAccountNumber) {
            validationErrors.confirmAccountNumber = 'Account numbers mismatch';
        }

        if(!bankDetails.ifscCode) {
            validationErrors.ifscCode = 'Required field';
        }

        if (!chequeFile || !(chequeFile instanceof File) || chequeFile.size === 0) {
            validationErrors.cancelledChequeUrl = 'Please upload a cancelled cheque';
        }

        if(Object.keys(validationErrors).length === 0) {
            setBankErrors(defaultBankErrors);
            navigate("/agreement");
        }
        else {
            setBankErrors(validationErrors);
        }
    }

    return (
        <div className='flex flex-col gap-6'>
            <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-4">
                    <h1 className="font-semibold text-[24px] leading-[44px] text-text1">Bank Details</h1>

                    <div className="flex flex-col gap-3">
                        <Input 
                            labelText='Account Holder Name' 
                            errorText={bankErrors.accountHolderName} 
                            inputOptions={{
                                type: 'text',
                                id: 'accountHolderName',
                                name: 'accountHolderName',
                                value: bankDetails.accountHolderName,
                                onChange: handleChange,
                                placeholder: 'Enter account holder name'
                            }}
                        />

                        <Input 
                            labelText='Account Number' 
                            errorText={bankErrors.accountNumber} 
                            inputOptions={{
                                type: 'password',
                                id: 'accountNumber',
                                name: 'accountNumber',
                                value: bankDetails.accountNumber,
                                onChange: handleChange,
                                placeholder: 'Enter account number'
                            }}
                        />

                        <Input 
                            labelText='Confirm Account Number' 
                            errorText={bankErrors.confirmAccountNumber} 
                            inputOptions={{
                                type: 'number',
                                id: 'confirmAccountNumber',
                                name: 'confirmAccountNumber',
                                value: bankDetails.confirmAccountNumber,
                                onChange: handleChange,
                                placeholder: 'Confirm account number'
                            }}
                        />

                        <Input 
                            labelText='IFSC Code' 
                            errorText={bankErrors.ifscCode} 
                            inputOptions={{
                                type: 'text',
                                id: 'ifscCode',
                                name: 'ifscCode',
                                value: bankDetails.ifscCode,
                                onChange: handleChange,
                                placeholder: 'Enter IFSC code'
                            }}
                        />
                    </div>
                </div>

                <div className="flex flex-col gap-4">
                    <div className="flex flex-col">
                        <h1 className="font-semibold text-[24px] leading-[44px] text-text1">Cancelled Cheque</h1>

                        <p className='font-medium text-base text-text2'>Please upload  cancelled cheque</p>
                    </div>

                    <label 
                        onDrop={handleDropCheque} 
                        onDragOver={handleDragOverCheque} 
                        onDragLeave={handleDragLeaveCheque} 
                        htmlFor='cancelled-cheque' className="cursor-pointer border-dashed bg-[#E5E5E5] border-2 border-[#D1D5DB] w-full h-[140px] rounded-lg flex flex-col items-center justify-center gap-2"
                    >
                        <div className="w-12 h-12 flex items-center justify-center">
                            <img src={ImageAdd} alt="" />
                        </div>

                        <p className='font-medium text-sm text-[#4B5563] w-[90%] text-center'>
                            <span className='text-[#4F46E5]'>Click to Upload</span> or Drag or drop
                        </p>

                        <p className='font-medium text-[14px] leading-5 text-[#6B7280]'>PNG, JPG, PDF up to 10MB</p>
                    </label>

                    <input 
                        onChange={handleChequeSelection} 
                        className="hidden"
                        type="file" 
                        accept="image/png, image/jpeg, application/pdf" 
                        name="cancelled-cheque" 
                        id="cancelled-cheque" 
                    />

                    <p className='font-medium text-base text-text1'>{chequeFile.name}</p>

                    {
                        bankErrors.cancelledChequeUrl && 
                        <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{bankErrors.cancelledChequeUrl}</p>
                    }
                </div>
            </div>

            <button onClick={handleNext} className="w-full bg-primaryColor hover:bg-primaryAccent text-white px-3 py-4 rounded-[9px] font-semibold text-[18px] leading-6">Next</button>
        </div>
    )
}

function BankDetails() {
    const {
        loading,
    } = useContext(RegistrationContext);

    return (
        <>
            {loading && <LoadingTransparent />}

            <RegistrationLayout>
                <SectionComponent />
            </RegistrationLayout>
        </>
    )
}

export default BankDetails;